// extracted by mini-css-extract-plugin
export default {"container":"CTACard_container__cRpuR","cta":"CTACard_cta__5n1tb","button":"CTACard_button__sXt0W","iconContainer":"CTACard_iconContainer__8rCLT"};